import { Dispatch, SetStateAction, useEffect, useState } from 'react';

const READY_TIMEOUT_MS = 4000;

/**
 * Fallback layout catch-up for a player that takes too long to report readiness.
 *
 * NOTE: a "video never became ready" Sentry probe used to be armed here and was removed
 * deliberately — 4s is a *slowness* threshold, not a *failure* one, so on mobile it fired
 * for healthy videos and cost an event per slow session. Re-adding it needs a much longer
 * threshold plus sampling.
 */
const useVideoResizeFallback = (
  fallbackFn?: () => void
): Dispatch<SetStateAction<boolean>> => {
  const [videoIsReady, setVideoIsReady] = useState(false);

  useEffect(() => {
    const timeOut = window.setTimeout(() => {
      if (!videoIsReady) {
        fallbackFn && fallbackFn();
      }
    }, READY_TIMEOUT_MS);

    return () => {
      timeOut && clearTimeout(timeOut);
    };
  }, [fallbackFn, videoIsReady]);

  return setVideoIsReady;
};

export default useVideoResizeFallback;
